class GallerySwitcher extends HTMLElement {
  constructor() {
    super()

    this.switch = this.querySelector('.gallery-switcher__switch')
    this.inTheField = document.querySelector('.gallery--2')
    this.inTheFieldThumbs = document.querySelectorAll('.prd-Thumbnails_Item--in-the-field')
    this.studio = document.querySelector('.gallery--1')
    this.studioThumbs = document.querySelectorAll('.prd-Thumbnails_Item--studio')

    this.initialiseGallerySwitcher()
  }

  initialiseGallerySwitcher() {
    this.addEventListener('click', this.handleClick)
  }

  handleClick(event) {
    if (this.inTheField.classList.contains('hide')) {
      this.showInTheField()
    } else {
      this.showStudio()
    }
  }

  showInTheField() {
    this.studio.classList.add('hide')
    this.inTheField.classList.remove('hide')
    this.inTheFieldThumbs[0].click()
  }

  showStudio() {
    this.inTheField.classList.add('hide')
    this.studio.classList.remove('hide')
    this.studioThumbs[0].click()
  }
}

customElements.define('gallery-switcher', GallerySwitcher)
